const CUSTOM_APP_URL = 'https://flash.thesleepcompany.in';
const STOREFRONT_ACCESS_TOKEN = '7367503c032dfc2a581e05b2974ba71e';
const STOREFRONT_API_URL = '/api/2025-04/graphql.json';

var showOfferSection = false;
const inlineCouponCount = 4;
const inlineCoupon = [];

function formatDateWithSuffix(dateInput) {
  if (!dateInput || typeof dateInput !== 'string') return dateInput;

  const parsedDate = new Date(dateInput);
  if (isNaN(parsedDate.getTime())) return dateInput;

  // compare by date parts (local time)
  const isSameDay = (a, b) =>
    a.getFullYear() === b.getFullYear() &&
    a.getMonth() === b.getMonth() &&
    a.getDate() === b.getDate();

  const today = new Date();
  const tomorrow = new Date(today);
  tomorrow.setDate(today.getDate() + 1);

  if (isSameDay(parsedDate, today)) return 'Today';
  if (isSameDay(parsedDate, tomorrow)) return 'Tomorrow';

  const day = parsedDate.getDate();
  const month = parsedDate.toLocaleString('default', { month: 'long' });
  const year = parsedDate.getFullYear();
  const currentYear = today.getFullYear();

  const getSuffix = (d) => {
    if (d >= 11 && d <= 13) return 'th';
    switch (d % 10) {
      case 1: return 'st';
      case 2: return 'nd';
      case 3: return 'rd';
      default: return 'th';
    }
  };

  const suffix = getSuffix(day);
  return year === currentYear
    ? `on ${day}${suffix} ${month}`
    : `on ${day}${suffix} ${month} ${year}`;
}

function isPastDate(dateInput) {
  if (!dateInput || typeof dateInput !== 'string') return false;

  const d = new Date(dateInput);
  if (isNaN(d.getTime())) return false;

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const cmp = new Date(d);
  cmp.setHours(0, 0, 0, 0);

  return cmp.getTime() < today.getTime();
}

async function getCartItems() {
  const res = await fetch('/cart.js');
  const cart = await res.json();
  return cart.items.map((item) => ({
    merchandiseId: `gid://shopify/ProductVariant/${item.variant_id}`,
    quantity: item.quantity,
  }));
}

function isCollectionMatch(handleString) {
  const inputHandles = handleString
    .split(',')
    .map(h => h.trim().toLowerCase())
    .filter(Boolean);

  return window.productCollectionHandles.some(handle =>
    inputHandles.includes(handle.toLowerCase())
  );
}

async function testDiscountCode(allCartLines, discountCode) {
  if(discountCode.alwaysShow){


    if(discountCode.collectionsRestrict === "" || discountCode.collectionsRestrict === null){
      return {
        "code": discountCode.code,
        "applicable": true
      }
    }else{
      if (isCollectionMatch(discountCode.collectionsRestrict)) {
        return {
          "code": discountCode.code,
          "applicable": true
        }
      }
    }
  }

  await new Promise((resolve) => setTimeout(resolve, 300));

  try {
    const query = `
      mutation {
        cartCreate(input: {
          lines: [
            ${allCartLines
              .map(
                (line) => `{
              merchandiseId: \"${line.merchandiseId}\",
              quantity: ${line.quantity}
            }`
              )
              .join(',')}
          ],
          discountCodes: [\"${discountCode.code}\"]
        }) {
          cart {
            discountCodes {
              code
              applicable
            }
          }
        }
      }
    `;

    const res = await fetch(STOREFRONT_API_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': STOREFRONT_ACCESS_TOKEN,
      },
      body: JSON.stringify({ query }),
    });

    const json = await res.json();

    return json?.data?.cartCreate?.cart?.discountCodes?.[0];

  } catch (e) {
    console.warn('Discount API failed, skipping:', discountCode.code);
    return {
      code: discountCode.code,
      applicable: false,
    };
  }
}

async function checkEligibleDiscounts(discountCodes) {
  console.log('API data:', discountCodes);

  const variantIdInput = document.querySelector('product-form input[name="id"]');
  let varId;
  if (variantIdInput) {
    varId = variantIdInput.value;
  } else {
    varId = window.pdpOffersVariantId || '';
  }
  if (!varId) return;
  const cV = `gid://shopify/ProductVariant/${varId}`;

  const cartItems = await getCartItems();

  cartItems.push({ merchandiseId: cV, quantity: 1 }); // add current product

  const results = await Promise.all(discountCodes.map((code) => testDiscountCode(cartItems, code)));

  const eligible = results.filter((code) => code?.applicable);

  const filterredCodes = discountCodes.filter((item) => eligible.some((f) => f.code === item.code));

  return filterredCodes;
}

async function getData() {
  try {
    const res = await fetch(CUSTOM_APP_URL + '/api/get-discount?shop=' + Shopify.shop);
    const couponAPIData = await res.json();

    const couponList = [];
    const bankOfferList = [];
    const businessList = [];

    couponAPIData.forEach((offer) => {
      switch (offer.type) {
        case 'Coupon':
          couponList.push(offer);
          break;
        case 'Bank Offer':
          bankOfferList.push(offer);
          break;
        case 'No Cost EMI':
          bankOfferList.push(offer);
          break;
        default:
        case 'Business':
          businessList.push(offer);
          break;
          break;
      }
    });

    const filterredCouponList = await checkEligibleDiscounts(couponList);

    console.log('filterredCouponList', filterredCouponList);

    const mainOfferList = [];
    if (filterredCouponList && filterredCouponList.length) {
      mainOfferList.push({
        title: 'Coupon Offers',
        offers: filterredCouponList,
      });
    }
    if (bankOfferList.length) {
      mainOfferList.push({
        title: 'Bank Offers',
        offers: bankOfferList,
      });
    }
    if (businessList.length) {
      mainOfferList.push({
        title: 'Business Offers',
        offers: businessList,
      });
    }

    const offerWrapper = document.querySelector('.pdp-offers-list-wrapper');

    let index = 1;

    mainOfferList.forEach(({ title, offers }) => {
      const titleDiv = document.createElement('div');
      titleDiv.className = 'pdp-offers-list-title';
      titleDiv.textContent = title;
      offerWrapper.append(titleDiv);

      if(title === "Bank Offers"){
        const descDiv = document.createElement('div');
        descDiv.className = 'pdp-offers-list-note';
        descDiv.textContent = "These offers can be used on top of coupon discounts.";
        offerWrapper.append(descDiv);
      }

      showOfferSection = true;
      offers.forEach((offer) => {

        const expiryDate = offer?.customExpire && offer?.expiryDate
          ? offer.expiryDate
          : window.pdpOffersDefaultExpiry || '';

        if(offer?.customExpire && isPastDate(expiryDate)){
          return;
        }
        if (index <= inlineCouponCount) {
          inlineCoupon.push({
            stripTitle: offer?.stripTitle || offer?.code || "",
            stripDescription: offer?.stripDescription || offer?.title || "",
          });
          index++;
        }

        const item = document.createElement('div');
        item.className = 'pdp-offers-list-item';

        let offerIcon = '';

        if (offer.type === 'Coupon') {
          offerIcon = `<img src="${window.pdpOffersCopyIconUrl || ''}" class="copy-icon" data-copy="${offer.code}" alt="${offer.code}" width="32" height="32" >`;
        } else if (offer.code === 'UPI') {
          offerIcon = `<img src="${window.pdpOffersUpiIconUrl || ''}" width="32" height="32" >`;
        }



        var expiryString = `Offer ends ${formatDateWithSuffix(expiryDate)}`;
        if(offer?.hideExpiry){
          expiryString = '';
        }

        if(isPastDate(expiryDate)){
          expiryString = '';
        }

        let tcLabel = '';
        if (offer.tc != '') {
          tcLabel = `<div class="pdp-offer-item-tc">
                      *See T&C
                      <span>
                        <svg width="7" height="6" viewBox="0 0 7 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M4.65693 4.63415C4.26565 5.26346 3.34974 5.26346 2.95846 4.63415L1.02719 1.52802C0.613016 0.861894 1.09203 0 1.87642 0H5.73897C6.52336 0 7.00237 0.861892 6.5882 1.52802L4.65693 4.63415Z" fill="#CF2027"/>
                        </svg>
                      </span>
                    </div>`;
        }

        let offerLabel = offer?.cardTitle || offer?.code || "";

        item.innerHTML = `
          <div class="pdp-offer-card">
            <div class="pdp-offer-item-type">
              <span>${offerLabel}</span>
            </div>
            <div class="pdp-offer-item-content">
              <div class="pdp-offer-card-detail">
                <div class="pdp-offer-item-header">${offer.heading}</div>
                <div class="pdp-offer-item-title">${offer.title}</div>
                <div class="pdp-offer-item-desc">${offer.summary}</div>
              </div>
              <div class="pdp-offer-card-icon">
                ${offerIcon}
              </div>
              <div class="pdp-offer-item-footer">
                <div class="pdp-offer-item-expire">${expiryString}</div>
                  ${tcLabel}
              </div>
            </div>
          </div>
          <div class="pdp-offer-item-tc-content">
            <div class="pdp-offer-item-tc-wrapper">
              <p>Terms & Conditions</p>
              <div class="pdp-offer-item-tc-op">
                ${offer.tc}
              </div>
            </div>
          </div>
        `;
        offerWrapper.append(item);
      });
    });

    var inlineCouponContent = '';

    document.querySelectorAll('.copy-icon').forEach(function (el) {
      el.addEventListener('click', function () {
        const textToCopy = this.dataset.copy;
        navigator.clipboard.writeText(textToCopy).then(() => {
          const copiedSpan = document.createElement('span');
          copiedSpan.textContent = 'Copied!';
          copiedSpan.className = 'copied-msg';

          this.parentNode.insertBefore(copiedSpan, this.nextSibling);

          setTimeout(() => {
            copiedSpan.remove();
          }, 3000);
        });
      });
    });


    document.querySelectorAll('.pdp-offer-item-tc').forEach(function (el) {
      el.addEventListener('click', function () {
        const parentContent = this.closest('.pdp-offers-list-item')?.querySelector('.pdp-offer-item-tc-content');
        if (parentContent) {
          parentContent.classList.toggle('active');
          el.classList.toggle('active');
        }
      });
    });

    if (inlineCoupon.length) {
      const offerSlider = document.querySelector('.pdp-dynamic-offer .offer-slider-track');

      inlineCoupon.forEach((offer) => {
        inlineCouponContent += `<li class="splide__slide">
          <div class="offers-item">
            <span class="offer-name">${offer.stripTitle}</span>
            <span>${offer.stripDescription}</span>
          </div>
        </li>`;
      });

      offerSlider.innerHTML = inlineCouponContent;
    }
  } catch (err) {
    console.error('Fetch error:', err);
  }
}

getData();

// Sidebar and slider interactions
window.addEventListener('DOMContentLoaded', () => {
  const sidebar = document.querySelector('.pdp-dynamic-popup');
  const overlay = document.querySelector('.pdp-dynamic-popup-overlay');

  const openBtn = document.querySelector('.pdp-dynamic-ofer-header > a');
  const closeBtn = document.querySelector('.pdp-dynamic-popup .close-btn');

  openBtn.addEventListener('click', () => {
    sidebar.classList.add('open');
    overlay.classList.add('open');
  });

  closeBtn.addEventListener('click', () => {
    sidebar.classList.remove('open');
    overlay.classList.remove('open');
  });

  document.addEventListener('click', function (e) {
    if (sidebar.classList.contains('open') && !sidebar.contains(e.target) && e.target !== openBtn) {
      sidebar.classList.remove('open');
      overlay.classList.remove('open');
    }
  });

  const offerSlider = document.getElementById('offerSliderTrack');

  let isDown = false;
  let startX;
  let scrollLeft;

  offerSlider.addEventListener('mousedown', (e) => {
    isDown = true;
    offerSlider.classList.add('dragging');
    startX = e.pageX;
    scrollLeft = offerSlider.scrollLeft;
  });

  offerSlider.addEventListener('mouseleave', () => {
    isDown = false;
    offerSlider.classList.remove('dragging');
  });

  offerSlider.addEventListener('mouseup', () => {
    isDown = false;
    offerSlider.classList.remove('dragging');
  });

  offerSlider.addEventListener('mousemove', (e) => {
    if (!isDown) return;
    e.preventDefault();
    const x = e.pageX;
    const walk = x - startX;
    offerSlider.scrollLeft = scrollLeft - walk;
  });

});
